import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "pg_token";
export const RES_TOKEN_KEY = "res_token";

export const api = axios.create({ baseURL: API });
export const residentApi = axios.create({ baseURL: API });

residentApi.interceptors.request.use((c) => {
  const t = localStorage.getItem(RES_TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

residentApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && localStorage.getItem(RES_TOKEN_KEY) && !String(e.config?.url).includes("/auth/otp")) {
      localStorage.removeItem(RES_TOKEN_KEY);
      window.location.href = "/resident/login";
    }
    return Promise.reject(e);
  },
);

api.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401 && localStorage.getItem(TOKEN_KEY) && !String(e.config?.url).includes("/auth/otp")) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/login";
    }
    return Promise.reject(e);
  },
);

export function errMsg(e: any): string {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg.replace(/^Value error, /, "") : JSON.stringify(x))).join(" ");
  return typeof d.msg === "string" ? d.msg : String(d);
}

export async function openPdf(path: string, filename: string, client = api) {
  const win = window.open("", "_blank");
  const r = await client.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(new Blob([r.data], { type: "application/pdf" }));
  if (win) {
    win.location.href = url;
    return;
  }
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
}
